import { render, staticRenderFns } from "./usertags.vue?vue&type=template&id=3444051a&"
import script from "./usertags.vue?vue&type=script&lang=js&"
export * from "./usertags.vue?vue&type=script&lang=js&"
import style0 from "./usertags.vue?vue&type=style&index=0&id=3444051a&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3444051a')) {
      api.createRecord('3444051a', component.options)
    } else {
      api.reload('3444051a', component.options)
    }
    module.hot.accept("./usertags.vue?vue&type=template&id=3444051a&", function () {
      api.rerender('3444051a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/usertags.vue"
export default component.exports